import { render, staticRenderFns } from "./OrderTemplates.vue?vue&type=template&id=3ed0dd12&scoped=true&"
import script from "./OrderTemplates.vue?vue&type=script&lang=js&"
export * from "./OrderTemplates.vue?vue&type=script&lang=js&"
import style0 from "./OrderTemplates.vue?vue&type=style&index=0&id=3ed0dd12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed0dd12",
  null
  
)

/* custom blocks */
import block0 from "./OrderTemplates.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports